import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { ChangeCurrentClientDialogComponent } from './change-current-client-dialog/change-current-client-dialog.component';
import { Observable, of, Subject } from 'rxjs';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { KieneSession } from '../../../../../projects/kiene-core/src/lib/services/local-storage/kiene-session';
import { Mandant } from '../../../../../projects/kiene-core/src/lib/components/mandanten/classes/mandant';
import { SelectMandantDialogComponent } from '../../../dialogs/select-mandant-dialog/select-mandant-dialog.component';
import { Router } from '@angular/router';
import { SelectMandantDialogInput } from '../../../../../src/app/dialogs/select-mandant-dialog/select-mandant-dialog';
import { LoginService } from '../../../../../projects/kiene-core/src/lib/services/user/login.service';
import { ReleaseNotesService } from '../../../../../projects/kiene-core/src/lib/components/release-notes/release-notes.service';
import { ChangeCurrentClientDialogInput } from './change-current-client-dialog/change-current-client-dialog';

@Injectable({ providedIn: 'root' })
export class ChangeCurrentClientService {
    dialogRefClient: MatDialogRef<ChangeCurrentClientDialogComponent>;
    dialogRefMandant: MatDialogRef<SelectMandantDialogComponent>;

    constructor(
        public dialog: MatDialog,
        private readonly localStorageService: LocalStorageService,
        public router: Router,
        private readonly loginService: LoginService,
        private readonly releaseNotesService: ReleaseNotesService,
    ) {}

    public openChangeMandantDialog(disableClose: boolean, session: KieneSession) {
        this.closeDialogs();

        const input = new SelectMandantDialogInput(session?.mandanten);
        this.dialogRefMandant = this.dialog.open(SelectMandantDialogComponent, {
            maxWidth: '90%',
            data: input,
            disableClose: disableClose,
        });

        this.dialogRefMandant.afterClosed().subscribe(result => {
            const mandant: Mandant = result;
            if (mandant) {
                // user und Mandant setzen für API Request
                this.localStorageService.setCurrentClient(null, 'ChangeCurrentClientService');
                this.localStorageService.setCurrentUser(session);
                this.localStorageService.setCurrentMandant(mandant);
                this.loginService.reloadSession().subscribe({
                    next: (erfolgreich: boolean) => {
                        if (erfolgreich === true) {
                            const startseite = this.localStorageService.getStartseite();
                            this.router.navigate([startseite]);
                            this.releaseNotesService.scheduleCheck();
                        }
                    },
                });
            }
        });
    }

    public openChangeDialog(options?: { nurSchweinebetriebe?: boolean; nurRinderbetriebe?: boolean }): Observable<Client> {
        if (!this.localStorageService.hasPermission(4511)) {
            return of(undefined);
        }

        const clientSelectedSubject = new Subject<Client>();
        this.closeDialogs();

        const input = new ChangeCurrentClientDialogInput();
        input.client = this.localStorageService.getCurrentClient();
        if (options?.nurSchweinebetriebe === true) {
            input.nurSchweinebetriebe = true;
        }
        if (options?.nurRinderbetriebe === true) {
            input.nurRinderbetriebe = true;
        }
        this.dialogRefClient = this.dialog.open(ChangeCurrentClientDialogComponent, {
            minWidth: '1000px',
            maxWidth: '1000px',
            width: '100%',
            data: input,
        });

        this.dialogRefClient.afterClosed().subscribe(result => {
            if (result?.save) {
                this.localStorageService.setCurrentClient(result.client, 'ChangeCurrentClientService');
                clientSelectedSubject.next(result.client);
            }
            clientSelectedSubject.complete();
        });
        return clientSelectedSubject.asObservable();
    }

    private closeDialogs() {
        this.dialogRefClient?.close();
        this.dialogRefMandant?.close();
    }
}
